export default __webpack_public_path__ + "static/media/ramos_mejia.248c28cd.jpg";